/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { FileSpreadsheet, Maximize2 } from 'lucide-react';
import { BaseCardHeader } from './base-card-header';

interface SpreadsheetCardHeaderProps {
  title: string;
  backgroundColor?: string;
  relevanceValue: number;
  groupedCards?: any[];
  currentCardIndex: number;
  onClose: () => void;
  onImageExpand: () => void;
}

export const SpreadsheetCardHeader: React.FC<SpreadsheetCardHeaderProps> = ({
  onImageExpand,
  ...baseProps
}) => {
  const renderSpreadsheetContent = () => (
    <>
      <div className='flex h-full w-full items-center justify-center bg-primary/30'>
        <FileSpreadsheet size={64} className='text-white/80' />
      </div>
      
      <button
        className='absolute left-4 top-4 z-20 flex h-10 w-10 items-center justify-center rounded-full bg-black/40 text-white opacity-0 transition-opacity hover:bg-black/60 group-hover:opacity-100'
        onClick={onImageExpand}
        aria-label='View spreadsheet'
      >
        <Maximize2 size={18} />
      </button>
    </>
  );

  return (
    <BaseCardHeader {...baseProps}>
      {renderSpreadsheetContent()}
    </BaseCardHeader>
  );
};